<template>
  <div>
    <footer class="py-4 bg-blue text-white-50 text-left">
      <div v-if="!region">
        <img
          :src="require( `../assets/img/regioner/SE2321000016/footer.svg`)"
          alt="Footer för Region Stockholm"
          class="img-sthlm"
        />
        &nbsp;
        <!-- <img
          :src="require( `../assets/img/regioner/SE162321000255/footer.svg`)"
          alt="Footer för Region Skåne"
          class="img-skane"
        /> -->
      </div>
      <div v-if="region">
        <img
          :src="require( `../assets/img/regioner/` + region + `/footer.svg`)"
          alt="Footer för specifik region"
          class="img-footer"
        />
      </div>
      <div class="clearfix"></div>
      <p v-if="!region"> <!-- Ingen region -->
        Endokrinmottagningen Huddinge <br>
        141 86 Stockholm <br>
        <a href="tel:+46812380000">08-123 800 00</a> <br>
        © {{ getCurrentYear }} BCB Medical AB <br />
      </p>
      <p v-if="region === 'SE2321000016'"> <!-- Region Sthlm -->
        Endokrinmottagningen Huddinge <br>
        141 86 Stockholm <br>
        <a href="tel:+46812380000">08-123 800 00</a> <br>
        © {{ getCurrentYear }} BCB Medical AB <br />
      </p>
      <p v-if="region === 'SE162321000255'"> <!-- Region Skåne -->
        Skånes universitetssjukhus Malmö <br>
        214 28 Malmö <br>
        <a href="tel:+4640331000">040-33 10 00</a> <br>
        © {{ getCurrentYear }} BCB Medical AB <br />
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'bottom',
  data () {
    return {
      region: 'SE2321000016' // sessionStorage.getItem('region')
    }
  },
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
footer {
  position: relative !important;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  width: 100%;
}
footer p {
  color: #fff !important;
}
footer a {
  color: #fff !important;
}
.bg-blue {
  background: #069ccc !important;
}
.img-karolinska {
  max-width: 8%;
}
.img-skane {
  max-width: 3%;
}
.img-footer {
  height: 40px;
}
@media screen and (max-width: 800px) {
  footer {
    margin-top: 50px;
    padding-left: 15px;
  }
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
    .img-sthlm {
      max-width: 30%;
    }
    .img-skane {
      max-width: 15%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue